import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initBookingSentry } from "./lib/sentry";

initBookingSentry(
  import.meta.env as unknown as Record<string, string | undefined | boolean>,
);

createRoot(document.getElementById("root")!).render(<App />);
